import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { get_grid2d_key } from '@/utils/utils_grid2d';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { STATE__grid2d } from '../STATE__grid2d';

export const REMOTE__grid2d_get_generation = createAsyncThunkSafe<string[], string[]>(
  ENUM__network_event_client_to_server.GRID2D_GET_GENERATION,
  async (ids: string[]) => {
    await send_to_server(ENUM__network_event_client_to_server.GRID2D_GET_GENERATION, ids);

    return ids;
  },
);

export function INIT_REMOTE__grid2d_get_generation(builder: ActionReducerMapBuilder<STATE__grid2d>) {
  builder
    .addCase(REMOTE__grid2d_get_generation.pending, (state, action) => {
      for (let id of action.meta.arg) {
        let key = get_grid2d_key(ENUM__workspace_entity.ENTITY_GENERATION, id);

        state.grid2d_loading_in_progress.add(key);

        //need to force rerender
        state.grid2d_loading_in_progress = new Set(state.grid2d_loading_in_progress);
      }
    })
    .addCase(REMOTE__grid2d_get_generation.rejected, (state, action) => {})
    .addCase(REMOTE__grid2d_get_generation.fulfilled, (state, action: PayloadAction<string[]>) => {
      for (let id of action.payload) {
        get_grid2d_key(ENUM__workspace_entity.ENTITY_GENERATION, id);

        state.grid2d_loading_in_progress.delete(id);

        //need to force rerender
        state.grid2d_loading_in_progress = new Set(state.grid2d_loading_in_progress);
      }
    });
}
